import { useRef, useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { setCredentials } from '../redux/authSlice';

import axios from '../api/axios';
const LOGIN_URL = '/login';


const Login = () => {

	const navigate = useNavigate();

	const dispatch = useDispatch();

	const [searchParams] = useSearchParams();
	const surveyFromUrl = searchParams.get("survey");

	const qualtricsSurveyId = surveyFromUrl || sessionStorage.getItem("qualtricsSurveyId");

	const emailRef = useRef();
	const errRef = useRef();

	const [email, setEmail] = useState('');
	const [pwd, setPwd] = useState('');
	const [errMsg, setErrMsg] = useState('');
	const [showPasswords, setShowPasswords] = useState(false);

	useEffect(() => {
		setErrMsg('');
	}, [email, pwd])

	const isExternalUrl = (url) => {
		try {
			const urlObj = new URL(url, window.location.origin);
			return urlObj.origin !== window.location.origin;
		} catch {
			return false;
		}
	};
	const getRelativePath = (inputUrl) => {

		const origin = window.location.origin;
		const homepage = process.env.PUBLIC_URL || '';

		// console.log(`getRelativePath: origin: ${origin}`);
		// console.log(`getRelativePath: homepage: ${homepage}`);

		try {
			const url = new URL(inputUrl);

			if (!inputUrl.startsWith(origin)) {
				console.warn('URL does not match current origin');
				return '/';
			}

			let relativePath = url.pathname;
			if (homepage && relativePath.startsWith(homepage)) {
				relativePath = relativePath.substring(homepage.length);
			}

			// console.log(`getRelativePath: relativePath: ${relativePath + url.search + url.hash}`);

			return relativePath + url.search + url.hash;
		} catch (error) {
			console.error('Invalid URL:', error);
			return '';
		}
	}

	const handleSubmit = async (e) => {
		e.preventDefault();

		try {
			const response = await axios.post(LOGIN_URL,
				JSON.stringify({ email, password: pwd, survey: qualtricsSurveyId }),
				{
					headers: { 'Content-Type': 'application/json' },
					withCredentials: true
				}
			);
			// console.log(JSON.stringify(response?.data));
			const accessToken = response?.data?.accessToken;
			const isAdmin = response?.data?.isAdmin;
			const userId = response?.data?.userId;
			const surveyUrl = response?.data?.surveyUrl;
			const showBenchmarkingTour = response?.data?.showBenchmarkingTour;
			const showBenchmarkingHint = response?.data?.showBenchmarkingHint;
			const showInsightsTour = response?.data?.showInsightsTour;
			const profileComplete = response?.data?.profileComplete;
			dispatch(setCredentials({ email, userId, isAdmin, accessToken, showBenchmarkingTour, showBenchmarkingHint, showInsightsTour, profileComplete }));

			setEmail('');
			setPwd('');

			const redirectPath = sessionStorage.getItem("redirectAfterAuth");
			sessionStorage.removeItem("redirectAfterAuth");
			sessionStorage.removeItem("qualtricsSurveyId");

			console.log(`surveyUrl: ${surveyUrl} redirectAfterAuth: ${redirectPath}`);

			if (surveyUrl) {
				if (isExternalUrl(surveyUrl)) {
					window.location.href = surveyUrl;
				} else {
					const relativePath = getRelativePath(surveyUrl);
					console.log(`relativePath: ${relativePath}`);
					navigate(relativePath);
				}
			} else if (redirectPath) {
				navigate(redirectPath);
			} else {
				navigate("/");
			}

		} catch (err) {
			if (!err?.response) {
				setErrMsg('No Server Response');
			} else if (err.response?.status === 429) {
				setErrMsg('You\'ve exceeded the maximum number of login attempts. Please wait 30 minutes, and try again with the correct credentials.');
			} else {
				setErrMsg('Either your email address or password is incorrect, or your email address is unverified.');
			}
			errRef.current.focus();
		}
	}

	return (

		<section style={{ maxWidth: '480px' }}>
			<p ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
			<h1>Sign In</h1>
			<form onSubmit={handleSubmit}>
				<label htmlFor="email">Email:</label>
				<input
					type="email"
					id="email"
					ref={emailRef}
					autoComplete="off"
					onChange={(e) => setEmail(e.target.value)}
					value={email}
					required
				/>

				<label htmlFor="password">Password:</label>
				<input
					type={showPasswords ? "text" : "password"}
					id="password"
					onChange={(e) => setPwd(e.target.value)}
					value={pwd}
					required
				/>

				<div className="checkbox-and-label" style={{ marginTop: '1rem' }}>
					<input
						type="checkbox"
						id="password_visibility"
						name="password_visibility"
						checked={showPasswords}
						onChange={(e) => setShowPasswords(e.target.checked)}
					/>
					<label htmlFor="password_visibility">Show password</label>
				</div>

				<button>Sign In</button>
			</form>
			<nav>
				<Link to="/resetpassword">Forgot password?</Link>
				<Link to="/register">Register</Link>
			</nav>
		</section>

	)
}

export default Login
